import { OrganizationListManager } from "@/components/organization-list/OrganizationListManager.tsx";
import { ApiOrganizationListType } from "@/types/organization-list.types.ts";
import { Modal, ModalProps, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface OrganizationListEditModalProps extends ModalProps {
  type: ApiOrganizationListType;
}

export function OrganizationListEditModal({ type, ...props }: OrganizationListEditModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const { id } = props;

  return (
    <Modal
      {...props}
      variant="middle"
      size="lg"
      title={t("common:manage_list")}
      withCloser
      closeByEscEnabled
    >
      <OrganizationListManager
        type={type}
        onSaved={() => {
          close(id);
        }}
      />
    </Modal>
  );
}
